<script setup lang="ts">
// Components
import ChartByZone from '~/app-modules/explore/components/chart/byZone.vue';
import ZoneTable from '../../components/table/zone.vue';

// Composables
const { getKeysFromForage } = useExploreStorage();
const { loadZoneData } = useZoneService();

onMounted(async () => {
  await getKeysFromForage();
  loadZoneData();
});
</script>
<template>
  <div class="w-full flex-1 flex flex-col gap-4">
    <div class="w-full h-full bg-white border border-gray-200 rounded-lg p-1">
      <chart-by-zone />
    </div>
    <ui-card class="w-full h-full">
      <zone-table />
    </ui-card>
  </div>
</template>
